{
	"page": {
		"title": "Quotas",
		"intro": "How many cards each organisation may register per category. Over quota is shown on View Records, never blocked.",
		"failed": "Quotas could not be loaded.",
		"retry": "Try again"
	},
	"filters": {
		"games": "Games",
		"organisation": "Organisation",
		"search": "Search organisations"
	},
	"kinds": {
		"REQUIRED": "Required",
		"RATIO": "Ratio"
	},
	"card": {
		"title": "Quota",
		"subtitle": "{{scope}}. Rejected and withdrawn cards are not counted.",
		"allOrganisations": "All organisations",
		"oneOrganisation": "One organisation",
		"totalTitle": "Live cards against the total quota",
		"ofQuota": "/ {{quota}}",
		"tabsLabel": "Quota by",
		"perFunction": "Per function",
		"perOrganisation": "Per organisation",
		"functionsOver_one": "{{n}} function over quota",
		"functionsOver_other": "{{n}} functions over quota",
		"organisationsOver_one": "{{n}} organisation over quota",
		"organisationsOver_other": "{{n}} organisations over quota",
		"allWithin": "All within quota",
		"failed": "Quotas could not be loaded.",
		"empty": "No cards and no quotas for this selection yet.",
		"filterBy": "Show only {{name}}",
		"showLess": "Show less",
		"showAll_one": "Show all {{n}}",
		"showAll_other": "Show all {{n}}",
		"hintFunction": "Open a row for its sub-functions. Filter records narrows the list below.",
		"hintOrganisation": "Pick an organisation to filter the list and see its quota per function.",
		"overQuota": "Over quota",
		"noQuota": "No quota set",
		"over": "{{n}} over",
		"left": "{{n}} left",
		"barLabel": "{{used}} of {{quota}}",
		"subFunctions": "Sub-functions",
		"filterRecords": "Filter records",
		"noSubFunctions": "No cards in this category yet.",
		"noSubFunction": "No sub-function",
		"registered_one": "{{n}} registered",
		"registered_other": "{{n}} registered",
		"unquoted_one": "+{{n}} in an organisation with no quota",
		"unquoted_other": "+{{n}} in organisations with no quota"
	},
	"gender": {
		"women": "Women {{n}}",
		"men": "Men {{n}}",
		"between": "({{min}}–{{max}})",
		"atLeast": "(min {{min}})",
		"atMost": "(max {{max}})"
	},
	"violation": {
		"text": "{{subject}}: {{actual}} registered, {{required}} needed"
	},
	"overview": {
		"title": "All organisations",
		"summary": "{{used}} live cards against a total quota of {{quota}}. Pick an organisation to see or change its quotas.",
		"pick": "Pick an organisation to see or change its quotas.",
		"hint": "Over quota first. Click a row to open that organisation.",
		"emptyTitle": "No organisations",
		"emptyDescription": "Add responsible organisations first.",
		"table": {
			"organisation": "Organisation",
			"type": "Type",
			"used": "Used",
			"quota": "Quota",
			"status": "Status"
		}
	},
	"editor": {
		"title": "{{name}}",
		"summary": "{{used}} live cards against a total quota of {{quota}}.",
		"noQuota": "No quota",
		"unsaved_one": "{{n}} category changed",
		"unsaved_other": "{{n}} categories changed",
		"discard": "Discard changes",
		"save": "Save quotas",
		"saved": "Saved the quotas of {{name}}",
		"saveFailed": "Could not save the quotas",
		"invalid": "Check the highlighted numbers.",
		"cellLabel": "{{field}} for {{category}}",
		"emptyTitle": "No categories",
		"emptyDescription": "Add categories under Main / Sub Functions first.",
		"hintWrite": "Leave a quota empty for no quota. Saving replaces this organisation's quotas for the selected games.",
		"hintRead": "Only a Super Admin can change quotas.",
		"table": {
			"category": "Category",
			"used": "Used",
			"quota": "Quota",
			"womenMin": "Women min",
			"womenMax": "Women max",
			"menMin": "Men min",
			"menMax": "Men max",
			"status": "Status"
		},
		"status": {
			"none": "No quota",
			"left": "{{n}} left ({{pct}}%)",
			"over": "{{n}} over ({{pct}}%)"
		}
	},
	"rules": {
		"title": "Rules",
		"count_one": "{{n}} rule",
		"count_other": "{{n}} rules",
		"intro": "Checked against the live cards of each organisation. A rule not met is shown, never blocked.",
		"add": "Add rule",
		"failed": "Rules could not be loaded.",
		"emptyTitle": "No rules for this games",
		"emptyWrite": "Add one, such as a Chef de Mission being required.",
		"emptyRead": "A Super Admin can add them.",
		"pagination_one": "{{from}}–{{to}} of {{total}} rule",
		"pagination_other": "{{from}}–{{to}} of {{total}} rules",
		"editLabel": "Edit rule",
		"deleteLabel": "Delete rule",
		"whoAll": "Every organisation",
		"whoType": "Every {{type}}",
		"subjectWithSub": "{{sub}} ({{main}})",
		"sentence": {
			"required_one": "{{who}}: at least {{n}} card in {{subject}}",
			"required_other": "{{who}}: at least {{n}} cards in {{subject}}",
			"ratio_one": "{{who}}: at least 1 card in {{subject}} for every card in {{per}}",
			"ratio_other": "{{who}}: at least 1 card in {{subject}} for every {{n}} cards in {{per}}"
		},
		"table": {
			"rule": "Rule",
			"kind": "Kind",
			"active": "Active",
			"updated": "Updated",
			"on": "On",
			"off": "Off"
		},
		"form": {
			"addTitle": "Add rule",
			"editTitle": "Edit rule",
			"description": "Rules are checked for each organisation of the games.",
			"add": "Add rule",
			"save": "Save rule",
			"kind": "Kind",
			"kindHint": {
				"REQUIRED": "At least a number of cards in a category",
				"RATIO": "One card in a category for every N in another"
			},
			"organisationType": "Applies to",
			"organisationTypeHint": "Empty = every organisation.",
			"subject": "Category to count",
			"subjectSub": "Sub-function",
			"categoryPlaceholder": "Choose a category",
			"anySub": "Any sub-function",
			"minCount": "At least",
			"minCountHint": "Cards needed in that category.",
			"per": "For every … in",
			"perSub": "Of sub-function",
			"perCount": "Every",
			"perCountHint": "One card is needed for every this many.",
			"active": "Active"
		},
		"toast": {
			"added": "Rule added",
			"updated": "Rule saved",
			"deleted": "Rule deleted",
			"addFailed": "Could not add the rule",
			"updateFailed": "Could not save the rule"
		},
		"delete": {
			"title": "Delete this rule?",
			"description": "“{{rule}}” will no longer be checked.",
			"confirm": "Delete rule",
			"failed": "Could not delete the rule"
		}
	},
	"validation": {
		"quotaRequired": "Enter a quota",
		"valueInvalid": "A whole number from 0 to {{max}}",
		"womenRange": "Women min cannot exceed women max",
		"menRange": "Men min cannot exceed men max",
		"minimumsOverQuota": "Women and men minimums together exceed the quota",
		"rowsMax": "At most {{max}} categories at once",
		"rowDuplicate": "This category is listed twice",
		"countInvalid": "A whole number from 1 to {{max}}",
		"minCountRequired": "Enter how many are needed",
		"perRequired": "Choose what is counted and how many per card",
		"subjectRequired": "Choose a category"
	}
}
